
import React from 'react';

interface DealFeaturesProps {
  /** List of feature descriptions to display */
  features: string[];
}

/**
 * Renders a section containing a list of key features.
 *
 * The component is defensive against missing or empty `features` props.
 * If `features` is not an array, it will be treated as an empty list to
 * avoid runtime crashes.
 */
export default function DealFeatures({ features }: DealFeaturesProps) {
  // Ensure `features` is always an array – prevents “undefined.map” errors.
  const safeFeatures = Array.isArray(features) ? features : [];

  return (
    <section className="px-6 lg:px-8 pb-16">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white/[0.03] border border-white/5 rounded-none p-8 lg:p-10">
          <h2 className="text-xl font-bold text-white mb-8 flex items-center gap-3">
            <div className="w-8 h-8 bg-neon/10 flex items-center justify-center rounded-none">
              <i className="ri-check-double-line text-neon text-lg"></i>
            </div>
            Key Features
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {safeFeatures.map((feature, idx) => (
              <div
                key={idx}
                className="flex items-start gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-none"
              >
                <div className="w-6 h-6 bg-neon/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-neon text-sm"></i>
                </div>
                <span className="text-white/70 text-sm leading-relaxed">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
